import { createSelector, createFeatureSelector } from '@ngrx/store';
import { Network } from "../../models/network.interface";


export const selectNetwork = createFeatureSelector<Network>('network');

export const selectNetworkLoadingState = createSelector(
  selectNetwork,
  ({ loading }) => loading
);
